import type { SportType, HistoryCachedPayload } from '@/types';

/** Prefer metadata on JSON; fall back to ZWO sportType tag for older rows. */
export function inferSportFromCachedData(data: HistoryCachedPayload): SportType {
  if (data.sport === 'bike' || data.sport === 'run') return data.sport;
  const m = data.xml?.match(/<sportType>\s*(\w+)\s*<\/sportType>/i);
  if (m?.[1]?.toLowerCase() === 'run') return 'run';
  return 'bike';
}

export function formatHistoryEditDate(iso: string, lang: 'en' | 'pl'): string {
  const d = new Date(iso);
  if (lang === 'pl') {
    return d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function truncatePromptForTooltip(text: string | null | undefined, maxLen = 180): string {
  const s = (text ?? '').trim();
  if (!s) return '';
  return s.length <= maxLen ? s : `${s.slice(0, maxLen)}…`;
}
